import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const FillDocumentTaskDefinition: TaskDefinition<'DocumentsDocument'> = {
  taskableTypename: 'DocumentsDocument',
  getUrl: ({ info, navigation }) => {
    const documentId = info.id
    const folderId = info.folder?.id

    if (!documentId) {
      return null
    }

    return folderId
      ? navigation.documents.folderId.documentId.fullPath({ document_id: documentId, folderId })
      : navigation.documents.list.documentId.fullPath({ document_id: documentId })
  },
  getTitle: ({ info }) => {
    if (!info.filename) {
      return i18n.t('documents.tasks.fill_no_name')
    }

    const filename = info.extension ? info.filename.replace(info.extension, '') : info.filename

    return i18n.t('documents.tasks.fill', {
      filename,
    })
  },
}
